import { render } from "./topics.vue?vue&type=template&id=67fc7d64"
const script = {}
script.render = render

export default script